const handleMobileScrollReactWindow = (scrollDirection, scrollOffset) => {
  const actionBar = document.getElementById("action-bar");
  const notificationsBar = document.getElementById("navbar");
  const mobileBottomNav = document.getElementById("mobile-bottom-nav");
  const employerJobsIndexFilter = document.getElementById("job-index-filter");
  const employerJobsReactWindowWrapper = document.getElementById(
    "react-window-jobs-wrapper"
  );
  const mobileJobsIndexSearch = document.getElementById(
    "mobile-jobs-index-search"
  );
  const jobsIndexWrapper = document.getElementById("jobs-index-wrapper");
  const employerJobsIndexWrapper = document.getElementById(
    "employer-jobs-index-wrapper"
  );
  const addCandidateButton = document.getElementById("add-candidate-button");

  // react window - handle scroll directions
  if (scrollDirection === "forward" && scrollOffset !== 0) {
    if (actionBar) actionBar.classList.add("downScroll");
    if (notificationsBar) notificationsBar.classList.add("downScroll");
    if (mobileBottomNav) mobileBottomNav.classList.add("downScroll");
    if (employerJobsIndexFilter)
      employerJobsIndexFilter.classList.add("downScroll");
    if (employerJobsReactWindowWrapper)
      employerJobsReactWindowWrapper.classList.add("downScroll");
    if (mobileJobsIndexSearch)
      mobileJobsIndexSearch.classList.add("downScroll");
    if (jobsIndexWrapper) jobsIndexWrapper.classList.add("downScroll");
    if (employerJobsIndexWrapper)
      employerJobsIndexWrapper.classList.add("downScroll");
    if (addCandidateButton) addCandidateButton.classList.add("downScroll");
  } else {
    if (actionBar) actionBar.classList.remove("downScroll");
    if (notificationsBar) notificationsBar.classList.remove("downScroll");
    if (mobileBottomNav) mobileBottomNav.classList.remove("downScroll");
    if (employerJobsIndexFilter)
      employerJobsIndexFilter.classList.remove("downScroll");
    if (employerJobsReactWindowWrapper)
      employerJobsReactWindowWrapper.classList.remove("downScroll");
    if (mobileJobsIndexSearch)
      mobileJobsIndexSearch.classList.remove("downScroll");
    if (jobsIndexWrapper) jobsIndexWrapper.classList.remove("downScroll");
    if (employerJobsIndexWrapper)
      employerJobsIndexWrapper.classList.remove("downScroll");
    if (addCandidateButton) addCandidateButton.classList.remove("downScroll");
  }
};

export { handleMobileScrollReactWindow as default };
